import isEmpty from 'lodash/isEmpty';
import { forwardRef, useMemo } from 'react';
import MultiSelect, { MultiSelectProps } from './MultiSelect';

export type SimpleMultiSelectOption = Omit<MultiSelectProps<string>['options'][number], 'key'>;

interface Props extends Omit<MultiSelectProps<string>, 'options'> {
  emptyValue?: string;
  options: SimpleMultiSelectOption[];
}

const SimpleMultiSelect = forwardRef(
  ({ emptyValue, onChange, options, value, ...props }: Props, ref?: React.Ref<HTMLDivElement>) => {
    const o = useMemo(() => {
      return options.map((option) => ({ ...option, key: option.value }));
    }, [options]);

    return (
      <MultiSelect<string>
        {...props}
        ref={ref}
        onChange={onChange}
        options={o}
        value={isEmpty(value) ? (emptyValue ? [emptyValue] : []) : value}
      />
    );
  },
);

export default SimpleMultiSelect;
